import { Injectable } from '@angular/core';
import { Workbook } from 'exceljsAngular';
import * as FileSaver from 'file-saver';
import * as XLSX from 'xlsx';
const EXCEL_TYPE =
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
const EXCEL_EXTENSION = '.xlsx';
@Injectable({
  providedIn: 'root',
})
export class ExcelService {
  constructor() {}
  public exportAsExcelFile(json: any[], excelFileName: string): void {
    const workbook = this._generateFormat(json);
    this._exportFile(workbook, excelFileName);
  }
  private _generateFormat(json_data: Array<any>): Workbook {
    const workbook = new Workbook();
    let worksheet = workbook.addWorksheet('Employee Data');
    const colorBGHeader = 'FFFF6900';
    const colorFontHeader = 'FFFFFFFF';
    json_data.forEach((rowData: Array<string>, index) => {
      const worksheetRow = worksheet.addRow(rowData);
      if (index === 0) {
        rowData.forEach((value, index) => {
          const cell = worksheetRow.getCell(index + 1);
          cell.fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: colorBGHeader },
          };
          cell.font = {
            bold: true,
            color: { argb: colorFontHeader },
          };
        });
      }
    });
    return workbook;
  }
  private _exportFile(workbook: Workbook, fname: string): void {
    workbook.xlsx.writeBuffer().then((data) => {
      let blob = new Blob([data], {
        type: EXCEL_TYPE,
      });
      FileSaver.saveAs(
        blob,
        fname + '-' + new Date().valueOf() + EXCEL_EXTENSION
      );
    });
  }
  private saveAsExcelFileV1(buffer: any, fileName: string): void {
    const data: Blob = new Blob([buffer], { type: EXCEL_TYPE });
    FileSaver.saveAs(data, fileName + new Date().getTime() + EXCEL_EXTENSION);
  }
}
